import SetupAxios from '../../../../setup/axios/SetupAxios'

export async function Post<T>(endpoint: string, data: unknown): Promise<T> {
    try {
        const response = await SetupAxios.post<T>(endpoint, data)
        return response.data
    } catch (error) {
        console.error('Error posting data:', error)
        throw error
    }
}
